import Application from "../../Application";

export default function() {
    Application.Common.manageCommissionsTable();
}